export default function setupGameConfig(variantId) {
  const config = {
    // add your game config options here, these can be the default values
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  return config;
}